<script lang="ts">
  import Shuffle from '~icons/mdi/shuffle';
  import ActionButton from '../components/ActionButton.svelte';
  import { tick } from 'svelte';

  type Props = {
    onShuffle: () => void;
    shuffles: number;
  };
  let props: Props = $props();

  // svelte-ignore state_referenced_locally
  let prevShuffles = $state(props.shuffles);
  let increment = $state(false);

  $effect(() => {
    if (prevShuffles < props.shuffles) {
      increment = false;
      tick().then(() => {
        increment = true;
      });
      prevShuffles = props.shuffles;
    }
  });
</script>

<div class="shuffle-container" class:increment>
  <ActionButton
    onClick={props.shuffles > 0 ? props.onShuffle : undefined}
    disabled={props.shuffles === 0}
  >
    <span>
      {props.shuffles}
    </span>
    <Shuffle />
  </ActionButton>
</div>

<style lang="scss">
  @use '~/theme/theme';
  @use '~/theme/include-media' as *;
  .shuffle-container {
    @include media('height<tablet') {
      font-size: 1rem;
    }
    span {
      padding: 0.25em;
    }
    &.increment :global(button) {
      @include theme.pulse-animation(theme.$star-bonus);
    }
  }
</style>
